// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__32xhA","title":"AfterFrontImage_title__45ctN"};